import React, { useState } from 'react';
import { usersApi } from '../services/api';
import appLogo from '../images/american_pub_poker.jpg';
import './Login.css';

function Login({ onLogin }) {
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const formatPhoneDisplay = (value) => {
    // Strip non-digits
    const digits = value.replace(/\D/g, '');
    // Format as (XXX) XXX-XXXX
    if (digits.length <= 3) return digits;
    if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
  };

  const handlePhoneChange = (e) => {
    const formatted = formatPhoneDisplay(e.target.value);
    setPhone(formatted);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const digits = phone.replace(/\D/g, '');
    if (!digits || digits.length < 10) {
      setError('Please enter a valid 10-digit phone number.');
      return;
    }
    if (!password.trim()) {
      setError('Please enter your password.');
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const response = await usersApi.login(digits, password.trim());

      if (response.success && response.data?.id) {
        const roles = response.data.roles || [];
        const firstName = response.data.firstName || response.data.first_name || '';
        const lastName = response.data.lastName || response.data.last_name || '';
        onLogin(response.data.username, response.data.id, roles, firstName, lastName);
      } else {
        setError('Invalid phone number or password.');
      }
    } catch (err) {
      console.error('Login error:', err);
      setError(err.message || 'Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="status-bar">
        <span className="time">9:41</span>
        <div className="status-icons">
          <span className="signal"></span>
          <span className="wifi"></span>
          <span className="battery"></span>
        </div>
      </div>

      <div className="login-content">
        <div className="logo-container">
          <img src={appLogo} alt="American Pub Poker" className="app-logo" />
          <h1 className="app-title">American Pub Poker</h1>
        </div>

        <form className="login-form" onSubmit={handleSubmit}>
          <div className="input-group">
            <input
              type="tel"
              placeholder="Phone Number"
              value={phone}
              onChange={handlePhoneChange}
              className="login-input"
              autoFocus
            />
          </div>

          <div className="input-group">
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="login-input"
            />
          </div>

          {error && <div className="login-error">{error}</div>}

          <button type="submit" className="login-button" disabled={loading}>
            {loading ? 'Signing In...' : 'Sign In'}
          </button>
        </form>

        <div className="login-footer">
          <p>Find and join poker games near you</p>
        </div>
      </div>
    </div>
  );
}

export default Login;
